export default "__VITE_ASSET__CCwzJn61__"